import React from 'react';
import Errorpage from './section-components/ErrorContent';

const Error = () => {
    return <div>
        <Errorpage />
    </div>
}

export default Error

